// Site d'une société et sa provenance (`companies.domain`, `domain_method`, `domain_source_url`).

const METHODS = ["notice", "wikidata", "search", "manual"] as const;
export type SiteMethod = (typeof METHODS)[number] | "unknown";

/** Adresse à ouvrir : celle enregistrée si elle est sur le domaine trouvé, sinon la racine du domaine. */
export const siteHref = (
  domain: string | null | undefined,
  website: string | null | undefined,
): string | null => {
  if (!domain) return null;
  if (website) {
    try {
      const host = new URL(website).hostname.toLowerCase();
      const site = domain.toLowerCase();
      if (host === site || host.endsWith(`.${site}`)) return website;
    } catch {
      // Adresse saisie illisible : la racine du domaine.
    }
  }
  return `https://${domain}/`;
};

/** Méthode par laquelle le site a été trouvé, pour sa traduction. */
export const siteMethod = (method: string | null | undefined): SiteMethod =>
  (METHODS as readonly string[]).includes(method ?? "")
    ? (method as SiteMethod)
    : "unknown";
